module.exports = __webpack_public_path__ + "img/niu2.a4a34087.png";